/**
 * Returns true iff `url` is an absolute https URL whose hostname is
 * stripe.com or any of its subdomains. Used to gate the two
 * `window.location.href = url` calls in PricingPage.tsx so a compromised
 * or buggy backend response cannot redirect a logged-in user to an
 * arbitrary site posing as the Stripe checkout.
 */
export function isStripeRedirectUrl(url: unknown): boolean {
  if (typeof url !== 'string' || url.length === 0) return false;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'https:') return false;
  const host = parsed.hostname.toLowerCase();
  return host === 'stripe.com' || host.endsWith('.stripe.com');
}
